<div class="card" #componentIdentifier>
  <div class="p-2">
    <nav #changeViewerNav class="changeViewerNav">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <!-- <div *ngIf="calcNavHeight()"></div> -->


        <a class="nav-item nav-link" *ngIf="checkRoutePermission('/change-viewer/regulatory-dashboard')"
          id="nav-change-viewer-open-tab" [routerLink]="['/change-viewer/regulatory-dashboard/']"
          [routerLinkActive]="['active']">Regulatory Dashboard</a>


        <a class="nav-item nav-link" *ngIf="checkRoutePermission('/change-viewer/trending-dashboard')"
          id="nav-change-viewer-trending-dashboard-tab" [routerLink]="['/change-viewer/trending-dashboard/']"
          [routerLinkActive]="'active'">Trending Dashboard </a>

        <a class="nav-item nav-link" *ngIf="checkRoutePermission('/change-viewer/open')" id="nav-change-viewer-open-tab"
          [routerLink]="['/change-viewer/open/']" [routerLinkActive]="'active'">Open <span
            *ngIf="sessionService.openRegulation >= 0">({{sessionService.openRegulation}})</span></a>
        <a class="nav-item nav-link" id="nav-change-viewer-future-updates-tab"
          *ngIf="checkRoutePermission('/change-viewer/future-updates')"
          [routerLink]="['/change-viewer/future-updates/']" [routerLinkActive]="['active']">Future Updates <span
            *ngIf="sessionService.futureRegulation >= 0">({{sessionService.futureRegulation}})</span></a>
        <a class="nav-item nav-link" id="nav-change-viewer-other-updates-tab"
          *ngIf="checkRoutePermission('/change-viewer/other-updates')" [routerLink]="['/change-viewer/other-updates/']"
          [routerLinkActive]="['active']">Filtered Out <span
            *ngIf="sessionService.otherRegulation >= 0">({{sessionService.otherRegulation}})</span></a>
        <a class="nav-item nav-link" id="nav-change-viewer-action-tab"
          *ngIf="checkRoutePermission('/change-viewer/actioned')" [routerLink]="['/change-viewer/actioned/']"
          [routerLinkActive]="['active']">Actioned <span
            *ngIf="sessionService.actionedRegulation >= 0">({{sessionService.actionedRegulation}})</span></a>
        <div class="d-webkit-inline display-content"
          *ngIf="regulationService.regulationLibrary && regulationService.regulationLibrary.length > 0">
          <ng-container *ngFor="let lib of regulationService.regulationLibrary">
            <span (click)="redirectLibrary(lib.id,lib.libraryType)"
              [attr.class]="sessionService.regLibraryId >= 0 && sessionService.regLibraryId === lib.id ? 'nav-item nav-link active' : 'nav-item nav-link'">
              <a id="nav-impact-assessment-details-tab">
                <span [attr.class]="getIconClass(lib.libraryType)"></span> {{lib.libraryName}} <span
                *ngIf="lib.totalCount>0">({{lib.totalCount}})</span></a>
            </span>
          </ng-container>
        </div>
      </div>
    </nav>
    <div class="card-body">
      <!-- <div class="tab-content"> -->
      <router-outlet></router-outlet>
      <!-- </div> -->
    </div>
  </div>
</div>
<!-- <div class="card">
  <div class="p-2">
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a class="nav-item nav-link" *ngIf="checkRoutePermission('/change-viewer/regulatory-dashboard')"
          id="nav-change-viewer-open-tab" [routerLink]="['/change-viewer/regulatory-dashboard/']"
          [routerLinkActive]="['active']">Regulatory Dashboard</a>
        <a class="nav-item nav-link" *ngIf="checkRoutePermission('/change-viewer/open')" id="nav-change-viewer-open-tab"
          [routerLink]="['/change-viewer/open/']" [routerLinkActive]="['active']">Open <span
            *ngIf="sessionService.openRegulation >= 0">({{sessionService.openRegulation}})</span></a>
        <a class="nav-item nav-link" id="nav-change-viewer-future-updates-tab"
          *ngIf="checkRoutePermission('/change-viewer/future-updates')"
          [routerLink]="['/change-viewer/future-updates/']" [routerLinkActive]="['active']">Future Updates <span
            *ngIf="sessionService.futureRegulation >= 0">({{sessionService.futureRegulation}})</span></a>
        <a class="nav-item nav-link" id="nav-change-viewer-other-updates-tab"
          *ngIf="checkRoutePermission('/change-viewer/other-updates')" [routerLink]="['/change-viewer/other-updates/']"
          [routerLinkActive]="['active']">Not Applicable <span
            *ngIf="sessionService.otherRegulation >= 0">({{sessionService.otherRegulation}})</span></a>
        <a class="nav-item nav-link" id="nav-change-viewer-action-tab"
          *ngIf="checkRoutePermission('/change-viewer/actioned')" [routerLink]="['/change-viewer/actioned/']"
          [routerLinkActive]="['active']">Actioned <span
            *ngIf="sessionService.actionedRegulation >= 0">({{sessionService.actionedRegulation}})</span></a>
        <div class="d-webkit-inline display-content"
          *ngIf="regulationService.regulationLibrary && regulationService.regulationLibrary.length > 0">
          <ng-container *ngFor="let lib of regulationService.regulationLibrary">
            <span
              [attr.class]="sessionService.regLibraryId >= 0 && sessionService.regLibraryId === lib.id ? 'nav-item nav-link active' : 'nav-item nav-link'">
              <a href="/change-viewer/regulation-library/{{lib.id}}/{{lib.libraryType}}"
                id="nav-impact-assessment-details-tab">
                <span [attr.class]="getIconClass(lib.libraryType)"></span> {{lib.libraryName}} <span
                  *ngIf="sessionService.libraryRegulation >= 0 && sessionService.regLibraryId === lib.id">({{sessionService.libraryRegulation}})</span></a>
            </span>
          </ng-container>
        </div>
      </div>
    </nav>
    <div class="card-body">
      <div class="tab-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div> -->
